import React, { useEffect, useState } from "react";

import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import getLogger from "utils/logger.util.js";
import { INSIGHT_HISTORY_TABLE_STRINGS, InsightsStrings } from "constants/constantStrings";

import AgTable from "components/AgTable";
import Filter from "components/Filter";
import TableDialog from "components/TableDialog";

import { getHistoryInsight } from "../../../api/activeInsight";
import PageLoading from "../../../components/PageLoading/";
import { extractSystemId, formatDateLocalTZ } from "../../../utils/utils.js";
import InsightsSummary from "../InsightsSummary";

import { getInsightHistoryTableColDefs } from "./InsightsHistory.table.config";

import "../index.scss";

const InsightsHistory = () => {
  const Logger = getLogger("InsightsHistory");
  const [isLoaded, setIsLoaded] = useState(false);
  const [smartInsightsHistory, setSmartInsightsHistory] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [showTableFilterIcon, setShowTableFilterIcon] = useState(false);
  const columdefs = getInsightHistoryTableColDefs(showTableFilterIcon);
  const [insight, setInsight] = useState(null);
  const [popupData, setPopupData] = useState();
  const objAppInsights = useAppInsightsHandler();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sysId = extractSystemId();
        const response = await getHistoryInsight(sysId);
        if (response && response.status === 200) {
          const insights = response.data;
          setSmartInsightsHistory(insights);
        }
      } catch (err) {
        Logger.error("Error while fetching insight history: ", err);
      } finally {
        setIsLoaded(true);
      }
    };
    fetchData();
  }, []);

  const closePopup = () => setPopupData(null);
  const onRowClicked = event => {
    objAppInsights.trackEvent("insightsHistoryRowClick");
    openTableDialog(event.data);
  };

  const openTableDialog = insight => {
    const title = insight.AnomalyType === InsightsStrings.FIT1 ? InsightsStrings.feedFlow : InsightsStrings.brineFlow;
    const subTitle = InsightsStrings.viewHistory;
    const rowData = [
      {
        colName: INSIGHT_HISTORY_TABLE_STRINGS.insightName,
        colVal: title
      },
      {
        colName: INSIGHT_HISTORY_TABLE_STRINGS.tagName,
        colVal: insight.AnomalyType
      },
      {
        colName: INSIGHT_HISTORY_TABLE_STRINGS.insightDescription,
        colVal: insight.AnomalyType === InsightsStrings.FIT1 ? InsightsStrings.feedInsight : InsightsStrings.brineInsight
      },
      {
        colName: INSIGHT_HISTORY_TABLE_STRINGS.recommendation,
        colVal: InsightsStrings.recommendationDescription
      },
      {
        colName: INSIGHT_HISTORY_TABLE_STRINGS.startTime,
        colVal: formatDateLocalTZ(insight.CycleStartTime)
      },
      {
        colName: INSIGHT_HISTORY_TABLE_STRINGS.endTime,
        colVal: formatDateLocalTZ(insight.CycleEndTime)
      }
    ];
    const dialogData = { title, subTitle, rowData };
    setPopupData(dialogData);
  };

  return (
    <>
      {!isLoaded ? (
        <PageLoading customHeight={"calc(100vh - 150px)"} />
      ) : (
        <>
          <div className="flex-between marginBtm20">
            <div>
              <InsightsSummary descriptionText={InsightsStrings.insightsHistorydescription} />
            </div>
            <div className="jc-end">
              <Filter
                data={smartInsightsHistory}
                setFilterValue={setFilterValue}
                setShowTableFilterIcon={setShowTableFilterIcon}
                showTableFilterIcon={showTableFilterIcon}
                customClass="marginBtm10"
              />
            </div>
          </div>
          <AgTable
            rowData={smartInsightsHistory}
            quickFilterText={filterValue}
            setShowTableFilterIcon={setShowTableFilterIcon}
            showTableFilterIcon={showTableFilterIcon}
            columnDefs={columdefs}
            onRowClicked={onRowClicked}
            customHeight="calc(100vh - 215px)"
          />
          {popupData && <TableDialog popupData={popupData} closePopup={closePopup} colWidth="insight-history-table-dialog-col--width" />}
        </>
      )}
    </>
  );
};

export default InsightsHistory;
